import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/minesweeper.json";
import fr from "@/locales/fr/puzzle-types/minesweeper.json";

export const MINESWEEPER_NS = "puzzle-types/minesweeper";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerMinesweeperTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", MINESWEEPER_NS))
    i18n.addResourceBundle("en", MINESWEEPER_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", MINESWEEPER_NS))
    i18n.addResourceBundle("fr", MINESWEEPER_NS, fr, true, true);
}
